enum FieldType {

    Amount = "amount",
    Currency = "currency",
    CardName = "cardName",
    CardNumber = "cardNumber",
    CardExpiration = "cardExpiration",
    CardCvv = "cardCvv",
    PromotionCode = "promotionCode",
    IDCard = "idCard",
    BankID = "bank_id",
    Address = "address",
    CountryCode = "countryCode",
    City = "city",
    ZipCode = "zipCode",
    DateOfBirth = "dateOfBirth",
}

export {
    FieldType
};
